import React, { Component } from 'react';
import { Button } from 'antd';
import Auth from './Auth';
export default class AuthButton extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.props.onValidateEnd) {
            this.props.onValidateEnd(this.allowAccess);
        }
    }
    render() {
        let authcode = this.props.authcode;
        if (!Auth.validate(authcode)) {
            this.allowAccess = false;
            switch (this.props.authmode) {
                case 'disabled': return <Button {...this.props} disabled title="你没有权限使用此功能！"></Button>;
                    break;
                case 'visible':
                default: return null;
            }
        }
        this.allowAccess = true;
        return <Button {...this.props}></Button>
    }
}